import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';
import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

export const userReview = async (reviews, studyId) => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	const url = `${API_URL}/api/${role}/review`;
	let options = {
		headers: {
			token: `${token}`
		}
	};
	return axios.put(url, { id: studyId, reviews }, options);
};

export const sendToPIApproval = async (studyId) => {
	const token = getStoredTokenData().token;
	const url = `${API_URL}/api/qa/send/${studyId}`;
	let options = {
		headers: {
			token: `${token}`
		}
	};
	return axios.put(url, {}, options);
};

export const sendApproval = async (studyId) => {
	const token = getStoredTokenData().token;
	const url = `${API_URL}/api/pi/approve/${studyId}`;
	let options = {
		headers: {
			token: `${token}`
		}
	};
	return axios.put(url, {}, options);
};

export const getOutputResult = (id) => {
	window.open(`${API_URL}/api/admin/output/${id}`);
};

export const addPIComment = async (comment) => {
	const token = getStoredTokenData().token;
	return axios.post(
		`${API_URL}/api/qa/add-comment`,
		comment,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};
